import { createSelector } from 'reselect';
import get from 'lodash/get';

const getProfile = (state) => get(state, 'profile.profile', {});

export const getBankDetails = createSelector(getProfile, (profile) => {
  return get(profile, 'bankDetails', []);
});

export const getBankDetailsFormatted = createSelector(getBankDetails, (bankDetails) => {
  return bankDetails.map((account) => ({
    value: account._id,
    label: `${account.accountName} ${account.accountNumber}`,
    ...account, //todo: for compatibility with withdraw
  }));
});

export const getNotificationStyle = (action) =>
  action.error ? 'showNotificationError' : 'showNotificationInfo';

export const getAuthorisedPersons = createSelector(getProfile, (profile) =>
  get(profile, 'authorisedPersons', []).map((item) => ({
    ...item,
    relationship: item.otherRelationship || item.relationship,
  })),
);
